import React, { PureComponent } from "react";
import {
  Button,
  Wrapper,
  Row,
  Input,
  Icon,
  CardBody
} from "app/NativeComponents/common";

import { SliderPicker } from "react-color";
import tinycolor from "tinycolor2";
import { store } from "app/store";

class ColorPicker extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
      color: props.value
    };
  }

  renderColorPicker({ color, onChange }) {
    if (this.state.show) {
      const colors = store.getState().settings.colors;

      return (
        <CardBody
          style={{
            borderTopWidth: 1,
            borderTopColor: colors.border_color,
            borderTopStyle: "solid"
          }}
        >
          <SliderPicker
            color={color}
            onChange={color => {
              this.setState({ color });
            }}
            onChangeComplete={onChange}
          />
        </CardBody>
      );
    }
  }

  render() {
    const {
      style,
      ref_name,
      placeholder,
      onChange,
      onColorSelect,
      value
    } = this.props;
    const colors = store.getState().settings.colors;

    return (
      <Wrapper
        style={{
          ...style,
          borderBottomWidth: 1,
          borderBottomColor: colors.border_color
        }}
      >
        <Row>
          <Input
            style={{
              flex: 1
            }}
            ref={ref_name}
            name={ref_name}
            returnKeyType="done"
            blurOnSubmit={true}
            autoCapitalize="characters"
            keyboardType="default"
            placeholder={placeholder}
            onChange={onChange}
            value={value}
          />
          <Button
            onPress={() => {
              this.setState({ show: !this.state.show });
            }}
            style={{
              borderLeftWidth: 1,
              borderLeftColor: colors.border_color,
              borderLeftStyle: "solid",
              backgroundColor:
                value && value != "" ? value : colors.background_color,
              width: 50,
              alignSelf: "stretch",
              alignItems: "center",
              justifyContent: "center"
            }}
          >
            <Icon
              color={
                value && value != ""
                  ? tinycolor(value).isLight()
                    ? colors.text_color
                    : colors.white_color
                  : colors.text_color
              }
              icon="colorize"
            />
          </Button>
        </Row>
        {this.renderColorPicker({
          color: this.state.color,
          onChange: onChange
        })}
      </Wrapper>
    );
  }
}

export { ColorPicker };
